module.exports = __webpack_public_path__ + "img/biao.246b829a.png";